import { Chip as MuiChip, chipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Chip = styled(MuiChip)(({ theme }) => ({
  [`&.${chipClasses.root}`]: {
    cursor: 'pointer',
    ...theme.typography.buttonSmallRedesign,
  },
}));
